import { memo } from 'react';

interface NumberCellProps {
  value: number | null | undefined;
  decimals?: number;
  colorCoded?: boolean;
  locale?: string;
}

export const NumberCell = memo(({
  value,
  decimals = 0,
  colorCoded = false,
  locale = 'tr-TR'
}: NumberCellProps) => {
  if (value === null || value === undefined) {
    return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  }

  const formattedValue = value.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

  const color = colorCoded
    ? value > 0
      ? 'var(--color-positive)'
      : value < 0
        ? 'var(--color-negative)'
        : 'var(--color-text-primary)'
    : 'var(--color-text-primary)';

  return (
    <span
      style={{
        fontFamily: 'var(--font-mono)',
        fontVariantNumeric: 'tabular-nums',
        color,
        fontSize: '13px'
      }}
    >
      {formattedValue}
    </span>
  );
});

NumberCell.displayName = 'NumberCell';
